import { useContext } from 'react'
import SideScreenContext from '../Contexts/SideScreenContext'
import MutationSideScreen from '../../genericSidescreens/MutationSideScreen'
import SelectionSideScreen from '../../genericSidescreens/SelectSideScreen'
import DeleteSideScreen from '../../genericSidescreens/DeleteSideScreen'

const useSideScreen = () => {
  const setSideScreenFunc = useContext(SideScreenContext)
  const closeSideScreen = () => {
    let sideScreenArray = [...setSideScreenFunc.sideScreens]
    sideScreenArray.pop()
    setSideScreenFunc.setSideScreens(sideScreenArray)
  }

  const closeAllSideScreens = () => {
    let sideScreenArray = []
    setSideScreenFunc.setSideScreens(sideScreenArray)
  }
  const openSelectionSideScreen = (type, onSelected) => {
    openSideScreen(SelectionSideScreen, { data: { type: type }, notifyParent: onSelected })
  }
  const openDeleteSideScreen = (type,icon, object) => {
    openSideScreen(DeleteSideScreen, { data: { icon,type: type, object: object} })
  }
  const openMutationSideScreen = (mutationName,type,icon, object) => {
    openSideScreen(MutationSideScreen, { data: {mutationName:mutationName, icon,type: type, object: object} })
  }
  const openSideScreen = (component, options) => {
    let sideScreenArray = [...setSideScreenFunc.sideScreens]
    sideScreenArray.push({ component: component, options: options })
    setSideScreenFunc.setSideScreens(sideScreenArray)
  }

  return {
    openSideScreen: openSideScreen,
    closeSideScreen: closeSideScreen,
    openDeleteSideScreen:openDeleteSideScreen,
    openSelectionSideScreen: openSelectionSideScreen,
    openMutationSideScreen: openMutationSideScreen,
    closeAllSideScreens: closeAllSideScreens,
  }
}
export default useSideScreen
